import { IHostnameFilters } from '@/utils/types/hostnames';
import toast from 'react-hot-toast';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getApiStatus } from './fetchers';

export function useGetAPIStatus() {
  return useQuery(['status'], () => getApiStatus());
}
